import script from "./FilePreview.vue?vue&type=script&setup=true&lang=ts"
export * from "./FilePreview.vue?vue&type=script&setup=true&lang=ts"

import "./FilePreview.vue?vue&type=style&index=0&id=6cc3ea9a&scoped=true&lang=scss"

import exportComponent from "C:\\Users\\iab_b\\Documents\\Dev\\OA\\woah-transfer\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6cc3ea9a"]])

export default __exports__